export default __webpack_public_path__ + "static/media/backEnd.394c79bf.svg";